<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core'
import IconsMagic from '~/pages/magic/@components/Icons/Magic/index.vue'
import type { HeadingLevel } from '@/components/Heading/index.vue'

const { colors } = useTheme()

const breakpoints = useBreakpoints(breakpointsTailwind)

const isMobile = breakpoints.smallerOrEqual('md')

const headingSize: HeadingLevel = isMobile ? '5' : '4'
</script>

<template>
  <section flex="~ col" w-full items-center mb-50px>
    <div flex="~ col" items-center>
      <div flex items-center justify-center mb-12px>
        <IconFilledStar />

        <Heading style="font-family: Circular Std Bold, sans-serif" :level="headingSize" :color="colors.darkPurple" mr-2 ml-2>
          MAGICAL ENOUGH?
        </Heading>

        <IconFilledStar />
      </div>

      <h1 style="font-family: Circular Std Bold, sans-serif" font-600 text="36px <md:20px">
        Get started with Magic
      </h1>

      <NuxtLink
        :to="LINKS.extension.magicChromeWebStore"
        target="_blank"
        flex items-center justify-center bg-black w-17rem rounded-6 mt-36px mb-36px color-white font-500 pt-8px pb-8px hover-bg-purple
      >
        <IconsMagic size="26" background-color="transparent" />

        <Heading level="5" :color="colors.white" ml-5px>
          Install Plugin
        </Heading>
      </NuxtLink>
    </div>
  </section>
</template>
